import React from 'react';
import { NavLink } from 'react-router-dom';
import './styles.css';
function SubTabsInputs() {
  return (
    <div className="scrollable-container-app">
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <NavLink to="/inputs/forecasts" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Forecasts
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/inputs/cost-grid" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            CostGrid
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/inputs/cost-grid-transferts" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            CostGrid Transferts
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/inputs/products-price" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Products Price
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/inputs/returns" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Returns
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/inputs/forecasts-analysis" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Forecasts Analysis
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/inputs/budget-paid-warehouse" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Budget Amount Paid 
          </NavLink>
        </li>
      </ul>
    </div>
  );
}

export default SubTabsInputs;
